





















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Station} from "@/models/station";
import {Machine} from "@/models/machine";
import moment from "moment/moment";
import {Customer} from "@/models/customer";

@Component({})
export default class MaintenanceDialogComponent extends Vue {

  @Prop({default: false})
  public showDialog!: boolean;

  @Prop({default: []})
  public stations!: Station[];

  public searchText = '';

  public machines: Machine[] = [];

  public headers: any[] = [
    {
      text: 'Kunde',
      value: 'customerName'
    }, {
      text: 'Station',
      value: 'stationName'
    }, {
      text: 'Auftragsnummer',
      value: 'orderNo'
    }, {
      text: 'Seriennummer',
      value: 'serialNo'
    }, {
      text: 'Letzte Wartung',
      value: 'lastMaintenance'
    }, {
      text: 'Nächste Wartung ab',
      value: 'nextMaintenance'
    }, {
      text: 'Details',
      value: 'details'
    }];

  @Watch("stations", { immediate: true })
  public stationsChanged() {
    this.machines = this.stations.map(station => this.getMaintenanceMachines(station)).flat();
    this.machines = this.machines.sort((a, b) => a.nextMaintenanceDate!.getTime() - b.nextMaintenanceDate!.getTime());
  }

  public getMaintenanceMachines(station: Station): Machine[] {
    const currentDate = moment().endOf('day');
    const machines = station.machines.filter(machine => {
      (machine as any).stationName = station.name;
      (machine as any).customerName = (station.customer as Customer).name;
      const nextMaintenance = machine.nextMaintenance ? moment(machine.nextMaintenance, 'YYYY-MM-DD').toDate() : null;
      return nextMaintenance && nextMaintenance <= currentDate.toDate() && machine.maintenanceActive;
    });
    return machines;
  }

  public closed() {
    this.$emit('closed');
  }

  public openDetails(machine: Machine) {
    const station = this.stations.find(station => station.machines.find(m => m.id === machine.id));
    this.$router.push({name: 'station_details_view', params: {stationId: station!.id,
        customerId: (station!.customer as Customer).id}});
  }
}

